import dayjs from "dayjs";
import { isMobile, useAlertDialog } from "goi_common";
import { useCallback } from "react";

export type ObituaryShareTemplateArgs = Partial<{
  고인이름: string;
  관계: string;
  상주이름: string;
  날짜: string;
  발인: string;
  장례식장: string;
  빈소: string;
  사망표현: string;
}>;

/** 3관문 용 */
const useObituaryNativeShare = () => {
  const { openAlertDialog } = useAlertDialog();

  const shareObituaryMessage = useCallback(
    (obituary: ObituaryShareTemplateArgs, url: string) => {
      const message = getObituarySendMessageTemplate(obituary);
      const shareData: ShareData = {
        // title: `${obituary.고인이름}님의 부고`,
        text: message,
        url: url,
      };

      if (isMobile() && navigator.share) {
        navigator.share(shareData);
      } else {
        // 데스크톱 또는 공유 API를 지원하지 않는 경우의 대체 동작
        navigator.clipboard.writeText(url);
        openAlertDialog({
          content: "부고 공유 주소가 복사되었습니다.",
          buttonText: "확인",
        });
      }
    },
    []
  );

  return { shareObituaryMessage };
};

export default useObituaryNativeShare;

export const getObituarySendMessageTemplate = (
  obituary: ObituaryShareTemplateArgs
) => {
  return `
故 ${obituary.고인이름 || "미정"}님의 ${obituary.관계 || "미정"} ${
    obituary.상주이름 || "미정"
  } 님으로부터 도착한 부고입니다.

故 ${obituary.고인이름 || "미정"}님께서 ${
    formatDate(obituary.날짜 ?? "") || "미정"
  } ${obituary.사망표현 || "별세"}하셨기에 삼가 알려드립니다.

발인 : ${formatDate(obituary.발인 ?? "") || "미정"}
장례식장 : ${obituary.장례식장 || "미정"}
빈소 : ${obituary.빈소 || "미정"}

직접 연락을 드려야 하나 황망 중이라 모바일 부고장으로 부고를 알려 드림을 헤아려 주시기 바랍니다.
  `;
};

const formatDate = (date: string): string => {
  if (!date) return "";
  return dayjs(date).format("YYYY년MM월DD일");
};
